import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformancePermissionGrantProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-permission-grant-project-limit',
	path: '/jira/settings/system/performance/metrics/permissiongrant/projectlimit',
};
